import { useEffect, useState } from "react";
import { fetchCachedBlobUrl } from "@/lib/resources";
import { FileText, FileSpreadsheet, FileArchive, Presentation, Film, Image as ImageIcon, Link2, Youtube, File, Package } from "lucide-react";

export function fileTypeMeta(ft, kind) {
  const t = (ft || "").toLowerCase();
  if (kind === "youtube" || kind === "vimeo") return { Icon: Youtube, label: "Video", color: "text-red-400" };
  if (kind === "video_file" || ["mp4", "mov", "webm", "m4v"].includes(t)) return { Icon: Film, label: "Video", color: "text-purple-400" };
  if (kind === "external" || t === "link") return { Icon: Link2, label: "Link", color: "text-sky-400" };
  if (kind === "image" || ["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(t)) return { Icon: ImageIcon, label: t ? t.toUpperCase() : "Image", color: "text-emerald-400" };
  if (t === "pdf") return { Icon: FileText, label: "PDF", color: "text-rose-400" };
  if (["doc", "docx"].includes(t)) return { Icon: FileText, label: "Word", color: "text-blue-400" };
  if (["xls", "xlsx", "csv"].includes(t)) return { Icon: FileSpreadsheet, label: "Excel", color: "text-emerald-400" };
  if (["ppt", "pptx"].includes(t)) return { Icon: Presentation, label: "PowerPoint", color: "text-orange-400" };
  if (t === "zip") return { Icon: FileArchive, label: "ZIP", color: "text-amber-400" };
  if (t === "placeholder") return { Icon: Package, label: "Placeholder", color: "text-neutral-400" };
  return { Icon: File, label: t ? t.toUpperCase() : "File", color: "text-neutral-400" };
}

export function ResourceThumb({ resource, className = "" }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  const { Icon, color } = fileTypeMeta(resource.file_type, resource.kind);

  useEffect(() => {
    let active = true;
    if (resource.has_thumbnail) {
      fetchCachedBlobUrl(`/resources/${resource.id}/thumbnail`)
        .then((u) => { if (active) setUrl(u); })
        .catch(() => active && setFailed(true));
    }
    return () => { active = false; };
  }, [resource.id, resource.has_thumbnail]);

  if (resource.has_thumbnail && url && !failed) {
    return <img src={url} alt={resource.title} className={`h-full w-full object-cover ${className}`} data-testid="resource-thumb-img" />;
  }
  if (!resource.has_thumbnail && resource.youtube_id) {
    return <img src={`https://i.ytimg.com/vi/${resource.youtube_id}/hqdefault.jpg`} alt={resource.title} className={`h-full w-full object-cover ${className}`} data-testid="resource-yt-thumb" />;
  }
  return (
    <div className={`flex h-full w-full items-center justify-center bg-gradient-to-br from-[#181818] to-[#0d0d0d] ${className}`}>
      <Icon className={`h-10 w-10 ${color}`} strokeWidth={1.4} />
    </div>
  );
}
